export const GET_GROUP_USERS = 'GET_GROUP_USERS'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_AUTH_PROVIDER = 'SET_AUTH_PROVIDER'
export const SET_GROUP_USERS = 'SET_GROUP_USERS'
export const SET_USER_PREFERENCES = 'SET_USER_PREFERENCES'
export const UPDATE_ACCESS_TOKEN = 'UPDATE_ACCESS_TOKEN'
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER'
